import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import Login from "../../pages/Login";
import Forgot from "../../pages/Forgot";
import MyEstimates from "../Estimates/User";
import SharedEstimates from "../Estimates/Shared";
import ArchivedEstimates from "../Estimates/Archived";
import StartEstimate from "../Estimates/Templates";
import ManageAccount from "../../pages/ManageAccount";
import EditOrganization from "../../pages/EditOrganization";
import EditUser from "../../pages/EditUser";
import NewUser from "../../pages/NewUser";
import EditEstimate from "../../pages/EditEstimate";
import NewEstimate from "../../pages/NewEstimate";
import RequireAuth from "../shared/RequireAuth";
import LegacyEstimates from "../Estimates/Legacy";
import ViewV3Estimate from "../../pages/ViewV3Estimate";

export default function AppRoutes() {
  return (
    <Routes>
      <Route exact path="/login" element={<Login />} />
      <Route exact path="/forgot" element={<Forgot />} />

      <Route path="/" element={<RequireAuth />}>
        <Route exact path="/my" element={<MyEstimates />} />
        <Route exact path="/shared" element={<SharedEstimates />} />
        <Route exact path="/archived" element={<ArchivedEstimates />} />
        <Route exact path="/new" element={<StartEstimate />} />
        <Route exact path="/account" element={<ManageAccount />} />
        <Route exact path="/organizations/:id/edit" element={<EditOrganization />} />
        <Route exact path="/user/edit" element={<EditUser />} />
        <Route exact path="/user/new" element={<NewUser />} />
        <Route exact path="/edit/:id" element={<EditEstimate />} />
        <Route exact path="/new/:id" element={<NewEstimate />} />
        <Route exact path="/v3" element={<LegacyEstimates/>} />
        <Route exact path="/v3/view/:id" element={<ViewV3Estimate />} />
        <Route exact path="/" element={<Navigate replace to="/my" />} />
      </Route>
    </Routes>
  );
}
